import { render, staticRenderFns } from "./PatientsMembership.vue?vue&type=template&id=660f3fa3"
import script from "./PatientsMembership.vue?vue&type=script&lang=js"
export * from "./PatientsMembership.vue?vue&type=script&lang=js"
import style0 from "./PatientsMembership.vue?vue&type=style&index=0&id=660f3fa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports